// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Zt_o","name":"Header_name__1HcKz","birthday":"Header_birthday__2tZzp","skeleton":"Header_skeleton__3LDfJ"};